<div class="modal-body final-statement">
  <table class="table" style="background-color:white;">
    <tr>
      <td style="background-color:#0f2b46;color:white;" colspan="2">Please check your details before continue </td>
    </tr>
  </table>

  <div class="row align-items-center ">
    <div class="col-12 text-center currency">
      <table class="table table-hover text-center table-bordered">
        <tr>
          <td style="font-weight:bold;color:red;" colspan="2">Please confirm all transaction details are accurate. Processed transactions are non-reversible after payout to beneficiaries. Please note that transaction processing times might delay if and when transactions are subject to screening as required by law and international best practice, or pending final response from the mobile money operator or bank.</td>
          
        </tr>
        <tr>
          <td style="font-weight:bold;">Country Name :</td>
          <td>            {{data.beneficiary_country}}          </td>
        </tr>
        <tr>
          <td style="font-weight:bold;">Operator Name :</td>
          <td>{{data.OperatorName}} </td>
        </tr>
        <tr>
          <td style="font-weight:bold;">Service Name :</td>
          <td>{{data.serviceName}}</td>
        </tr>

        <tr>
          <td style="font-weight:bold;">Mobile No. :</td>
          <td>            {{data.beneficiary_phone}}          </td>
        </tr>
        <tr>
          <td style="font-weight:bold;">Account No. :</td>
          <td>            {{data.beneficiary_account_no}}          </td>
        </tr>
        <tr>
          <td style="font-weight:bold;">Amount :</td>
          <td>{{data.Amount}} USD</td>
        </tr>
        <tr>
          <td style="font-weight:bold;" *ngIf="data.serviceName == 'Transfer To Mobile Money' || data.serviceName =='Transfer To Bank' || data.serviceName =='Transfer To USD Domicile Bank Nigeria'|| data.serviceName =='Nigeria-Bank Transfer'">Service Charges + Platform Charges :</td>
          <td style="font-weight:bold;" *ngIf="data.serviceName == 'International Gift Voucher' || data.serviceName =='International Mobile Recharge'">Fee :</td>
          <td>{{data.commissionFee|number}} USD</td>
        </tr>
      </table>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-danger" [mat-dialog-close]="false">{{'Cancel'}}</button>
  <button type="button" class="btn btn-primary" [mat-dialog-close]="true">{{'Confirm'}}</button>
</div>
